import { Button } from "@/ui/Button";
import { Menu, Phone } from "lucide-react";
import type React from "react";

interface HeroButtonsProps {
  primaryButtonText: string;
  secondaryButtonText: string;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
}

const HeroButtons: React.FC<HeroButtonsProps> = ({
  primaryButtonText,
  secondaryButtonText,
  onPrimaryClick,
  onSecondaryClick,
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
      <Button
        variant="secondary"
        size="lg"
        onClick={onPrimaryClick}
        className="!bg-white !text-black hover:!bg-white/90 !border-white flex items-center gap-2"
      >
        <Menu className="w-5 h-5" />
        {primaryButtonText}
      </Button>
      {/* keep the secondary button (Reservation button) for future use, but hide it for now */}
      <Button
        variant="secondary"
        size="lg"
        onClick={onSecondaryClick}
        className="bg-black/60 text-white hover:bg-black/70 border border-white/30 flex items-center gap-2 hidden"
      >
        <Phone className="w-5 h-5" />
        {secondaryButtonText}
      </Button>
    </div>
  );
};

export default HeroButtons;
